module.exports = __webpack_public_path__ + "static/media/face_api.a9bdda6e.png";